/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class MinRetentionRule {
  /**
  * Whether the rule is enabled
  */
  'enabled': boolean;
  /**
  * The minimum backup retention period in days
  */
  'minimumRetention': number;
  /**
  * The frequency of the backup
  */
  'frequency': MinRetentionRuleFrequencyEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "minimumRetention",
      "baseName": "minimumRetention",
      "type": "number",
      "format": ""
    },
    {
      "name": "frequency",
      "baseName": "frequency",
      "type": "MinRetentionRuleFrequencyEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return MinRetentionRule.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum MinRetentionRuleFrequencyEnum {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Annual = 'ANNUAL'
}

